import { save1688GoodsData } from "@user-center/utils/webview/1688action.ts";
import { nwAppLog } from "@user-center/utils/nwLog.ts";
import { initNwWeight } from "@user-center/utils/nwWeight.ts";
import { initNwScan } from "@user-center/utils/nwScan.ts";
import { ElMessageBox } from "element-plus";
import Bus from "@user-center/bus";
import { get } from "lodash-es";
import { withOrigin } from "@user-center/utils/basePath";
import { setToken } from "@user-center/utils/auth";
import { setMallAppToken } from "@user-center/utils/qiankun";

const URL_SCHEME = "jiyun-helper";
const LAUNCH_META_FILE = "jiyun-helper-launch-meta.json";
const ZOOM_STEP = 0.5;
const PLATFORM_URL_MAP: Record<string, string> = {
  taobao: "https://main.m.taobao.com/olist/index.html",
  "1688": "https://trade2.m.1688.com/page/buyerOrderList.html",
  pdd: "https://mobile.yangkeduo.com/orders.html?type=3&comment_tab=1&order_index=1",
  jd: "https://trade.m.jd.com/order/orderlist_jdm.shtml?orderType=waitReceipt&source=m_inner_myJd.orderFloor_orderlist",
};

let isMainWin = false;

function applyLaunchMetaFromDataPath() {
  if (!window["require"] || !window["nw"]) {
    return;
  }

  try {
    const fs = window["require"]("fs");
    const path = window["require"]("path");
    const filePath = path.join(window["nw"].App.dataPath, LAUNCH_META_FILE);
    if (!fs.existsSync(filePath)) {
      return;
    }

    const raw = fs.readFileSync(filePath, "utf8");
    const data = JSON.parse(raw || "{}");
    const payload = data?.payload || {};
    const targetUrl = typeof data?.targetUrl === "string" ? data.targetUrl : "";
    nwAppLog(`applyLaunchMetaFromDataPath:${JSON.stringify({ payload, targetUrl })}`);

    if (payload?.token) {
      setToken(payload.token);
    }
    if (payload?.mallToken) {
      setMallAppToken(payload.mallToken);
    }

    const currentUrl = new URL(window.location.href);
    if (payload?.platform && !currentUrl.searchParams.get("platform")) {
      currentUrl.searchParams.set("platform", payload.platform);
      window.history.replaceState({}, "", currentUrl.toString());
    }

    if (targetUrl && window.location.href !== targetUrl) {
      const target = new URL(targetUrl);
      const currentPath = `${currentUrl.pathname}${currentUrl.search}`;
      const nextPath = `${target.pathname}${target.search}`;
      if (currentPath !== nextPath) {
        nwAppLog(`applyLaunchMetaFromDataPath:redirect:${targetUrl}`);
        window.location.replace(targetUrl);
      }
    }
  } catch (error) {
    nwAppLog(`applyLaunchMetaFromDataPath:error:${JSON.stringify(error && error.message ? error.message : String(error))}`);
  }
}

export function initNw() {
  if (window["require"] && window["nw"]) {
    nwAppLog("initNw");
    applyLaunchMetaFromDataPath();
    initNwWeight();
    initNwScan();
    // Load native UI library
    var gui = window["require"]("nw.gui");
    var win = gui.Window.get();

    const openPlatformWindow = (platform: string) => {
      const targetUrl = PLATFORM_URL_MAP[platform];
      if (!targetUrl) {
        return;
      }
      window.chrome.windows.create({
        incognito: false,
        focused: true,
        url: targetUrl,
      });
    };

    const setWindowZoom = (delta?: number) => {
      if (typeof delta === "number") {
        win.zoomLevel += delta;
      } else {
        win.zoomLevel = 0;
      }
    };

    nw.App.on("open", (args) => {
      const payload = extractLaunchPayload(args);
      if (payload?.url) {
        const targetUrl = transformLaunchUrl(payload);
        if (targetUrl) {
          window.location.href = targetUrl;
          return;
        }
      }

      window.chrome.windows.create({
        incognito: false,
        url: window.location.origin,
      });
    });
    // 创建window menu
    var windowMenu = new gui.Menu({ type: "menubar" });

    let setConcatMenus = [
      {
        label: "操作",
        submenu: [
          {
            label: "刷新",
            click: (menuItem, browserWindow, event) => {
              window.location.reload();
            },
          },
          {
            label: "复制当前网址",
            click: (menuItem, browserWindow, event) => {
              nw.Clipboard.get().set(window.location.href, "text");
            },
          },
          {
            label: "切换当前网址",
            click: (menuItem, browserWindow, event) => {
              const userInput = prompt("请输入网址", "切换当前网址");
              if (userInput !== null) {
                window.location.href = userInput;
              }
            },
          },
          {
            label: "在系统浏览器打开",
            click: () => {
              nw.Shell.openExternal(window.location.href);
            },
          },
        ],
      },
      
      {
        label: "视图",
        submenu: [
          { label: "放大", click: () => setWindowZoom(ZOOM_STEP) },
          { label: "缩小", click: () => setWindowZoom(-ZOOM_STEP) },
          { label: "恢复缩放", click: () => setWindowZoom() },
        ],
      },
    ];
    makeTreeMenu(windowMenu, setConcatMenus, gui);
    // eslint-disable-next-line node/prefer-global/process
    if (typeof process === "object" && process.platform === "darwin") {
      windowMenu.createMacBuiltin("erp");
    }

    win.menu = windowMenu;

    nw.Window.getAll((wins) => {
      nwAppLog("initWin" + wins.length);
      replaceIndexExitAppBug();
      let isWinLength = 0;

      wins.map((o) => {
        nwAppLog("urlWin" + get(o, "window.location.href"));
        if (get(o, "window.location.protocol", "").indexOf("http")>=0) {
          isWinLength += 1;
        }
      });
      if (isWinLength == 1) {
        nwAppLog("initAllTabScriptAndCssInsert"  );
        initAllTabScriptAndCssInsert();
        isMainWin = true;
        win.on("close", function () {
          this.hide();
          nwAppLog("主窗口关闭直接退出app");
          nw.App.quit();
        });
      }
    });
  }
}

function makeTreeMenu(windowSubmenu: any, menus: any[], gui: any) {
  menus.map((childMenu) => {
    if (childMenu.submenu && childMenu.submenu.length) {
      let windowChildSubmenu = new gui.Menu();
      makeTreeMenu(windowChildSubmenu, childMenu.submenu, gui);
      windowSubmenu.append(
        new gui.MenuItem({
          label: childMenu.label,
          submenu: windowChildSubmenu,
          click: childMenu.click ? childMenu.click : () => {},
        })
      );
    } else {
      windowSubmenu.append(
        new gui.MenuItem({
          label: childMenu.label,
          click: childMenu.click ? childMenu.click : () => {},
        })
      );
    }
  });
}

function safeDecode(value: string) {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function parseArgs(value: any) {
  if (Array.isArray(value)) {
    return value;
  }

  const input = String(value || "").trim();
  if (!input) {
    return [];
  }

  const args: string[] = [];
  const pattern = /"([^"]*)"|'([^']*)'|(\S+)/g;
  let matched;
  while ((matched = pattern.exec(input))) {
    args.push(matched[1] || matched[2] || matched[3] || "");
  }
  return args;
}

function extractLaunchPayload(rawValue: any) {
  const args = parseArgs(rawValue);
  if (!args.length) {
    return null;
  }

  for (let index = 0; index < args.length; index += 1) {
    const value = String(args[index] || "").trim().replace(/^"|"$/g, "");
    if (!value) {
      continue;
    }

    if (value === "--url" && args[index + 1]) {
      return { url: safeDecode(args[index + 1]) };
    }

    if (value.startsWith("--url=")) {
      return { url: safeDecode(value.slice(6)) };
    }

    if (value.startsWith(`${URL_SCHEME}://`)) {
      try {
        const parsed = new URL(value);
        const queryUrl = parsed.searchParams.get("url");
        const token = parsed.searchParams.get("token");
        const mallToken = parsed.searchParams.get("mallToken");
        const platform = parsed.searchParams.get("platform");
        const mode = parsed.searchParams.get("mode");
        const pathValue = parsed.pathname.replace(/^\/+/, "");
        return {
          mode,
          platform,
          token: token ? safeDecode(token) : "",
          mallToken: mallToken ? safeDecode(mallToken) : "",
          url: queryUrl ? safeDecode(queryUrl) : (pathValue ? safeDecode(pathValue) : ""),
        };
      } catch {
        const matched = value.match(/[?&]url=([^&]+)/);
        if (matched) {
          return { url: safeDecode(matched[1]) };
        }
      }
    }

    if (/^https?:\/\//i.test(value)) {
      return { url: value };
    }
  }

  return null;
}

function transformLaunchUrl(payload: any) {
  if (!payload?.url) {
    return "";
  }

  if (payload.mode === "app") {
    const businessUrl = new URL(payload.url);
    if (payload.token) {
      businessUrl.searchParams.set("setJyToken", payload.token);
    }
    if (payload.mallToken) {
      businessUrl.searchParams.set("setMallToken", payload.mallToken);
    }
    if (payload.platform) {
      businessUrl.searchParams.set("platform", payload.platform);
    }
    return businessUrl.toString();
  }

  return payload.url;
}

let insert1688ScriptStr = "";
let insert1688CssStr = "";
function initAllTabScriptAndCssInsert() {
  chrome.webNavigation.onCreatedNavigationTarget.addListener(
    async (details) => {
      console.log("details.url", details.url);

      if (details.url.indexOf("1688.com") >= 0) {
        // 1688脚本插入
        let insert1688ScriptUrl = withOrigin("/webview/script/insert1688Script.js");
        let insert1688CssUrl = withOrigin("/webview/css/insert1688Css.css");

        if (!insert1688ScriptStr) {
          insert1688ScriptStr = await getNetWorkFileContent(insert1688ScriptUrl);
        }
        if (!insert1688CssStr) {
          insert1688CssStr = await getNetWorkFileContent(insert1688CssUrl);
        }

        chrome.scripting.executeScript({
          target: { tabId: details.tabId },
          func: (insert1688ScriptStr, insert1688CssStr) => {
            // 插入 JavaScript

            // 插入 CSS
            const appendCss = (doc) => {
              const link = doc.createElement("style");
              link.type = "text/css";
              link.textContent = insert1688CssStr;
              doc.head.appendChild(link);
            };

            appendCss(document);
            setTimeout(() => {
              try {
                window.eval(insert1688ScriptStr);
              } catch (e) {
                alert(e);
              }
            }, 1000);
          },
          args: [insert1688ScriptStr, insert1688CssStr],
        });
      }
      // 注入脚本到新导航目标（新窗口或标签页）
    }
  );

  chrome.webRequest.onBeforeRequest.addListener(
    (details) => {
      if (details.url.indexOf("localhost:1111/cb") >= 0) {
        let dataStr = decodeURIComponent(
          details.url
            .replace("https://localhost:1111/cb?data=", "")
            .replace("http://localhost:1111/cb?data=", "")
        );
        console.log("dataStr", dataStr);
        let setData: any = {};
        try {
          setData = JSON.parse(dataStr);
        } catch (e) {}
        if (setData && setData.nwMessageType) {
          if (
            setData.nwMessageType == "handleCatch1688ProductList" &&
            setData.data
          ) {
            // 1688产品采集

            save1688GoodsData(setData.data, (res: any) => {
              if (res.success) {
                tipTab(details.tabId, res.msg);
              } else {
                tipTab(details.tabId, res.msg);
              }
            });
          }
        }
        // save1688GoodsData
        return { cancel: true };
      }

      // 你可以在这里修改或阻止请求
    },
    { urls: ["<all_urls>"] }, // 匹配所有 URL
    ["blocking"] // 使用阻塞模式，如果需要修改或阻止请求
  );
}

const NETWORK_FILE_CONTENT_CACHE: Record<string, string> = {}

export function getNetWorkFileContent(url: string) {
  if (NETWORK_FILE_CONTENT_CACHE[url]) {
    return Promise.resolve(NETWORK_FILE_CONTENT_CACHE[url])
  }
  return fetch(url).then(async (response) => {
    const content = await response.text() // 或 response.json()，视文件格式而定
    NETWORK_FILE_CONTENT_CACHE[url] = content
    return content
  })
}

export function tipTab(tabId, msg) {
  chrome.scripting.executeScript({
    target: { tabId: tabId },
    func: (msg) => {
      alert(msg);
    },
    args: [msg],
  });
}

function replaceIndexExitAppBug() {
  try {
    const fs = require("fs");
    const path = require("path");

    // 获取当前工作目录（安装目录）
    const currentDir = process.cwd();
    const indexJsPath = path.join(currentDir, "index.js");

    // 检查 index.js 文件是否存在
    if (fs.existsSync(indexJsPath)) {
      // 读取 index.js 文件内容
      fs.readFile(indexJsPath, "utf-8", (err, data) => {
        if (err) {
          console.error("读取文件出错:", err);
          return;
        }

        // 检测是否包含特定的 win.on("closed", () => { global.MAIN_WINDOW = null; })
        const targetPattern = /fix_closed_bug__0002/g;

        if (!data.match(targetPattern)) {
          console.log("检测到需要替换的代码，准备替换");

          // 替换的代码
          const newCode = `const printSetup = require("./server/print");
const setSetup = require("./server/setting");
const packageConfig = require("./package.json");
const path=require('path');
// 主进程
global.MAIN_WINDOW = null;
// 打印窗口
global.PRINT_WINDOW = null;
// 设置窗口
global.SET_WINDOW = null;
// 托盘
global.APP_TRAY = null;
// 菜单
global.APP_MENU = null;

// 初始化
async function initialize() {
  console.log("initialize");
  if (global.MAIN_WINDOW == null) {
    createWindow();
  } else {
    MAIN_WINDOW.focus();
  }

  initTray();

  printSetup();
}

async function createWindow() {
  const windowOptions = {
    width: 800,
    height: 600,
    show: true,
  };

  nw.Window.open("index.html", windowOptions, function (win) {
    global.MAIN_WINDOW = win;
    win.maximize();
    
    win.on("closed", () => {
      // fix_closed_bug__0001 强制关闭
      global.MAIN_WINDOW = null;
      killApp();
      nw.App.quit();
    });
  });
}

function initTray() {
  APP_TRAY = new nw.Tray({ title: packageConfig.name, icon: path.resolve(process.execPath,'../assets/pdtray.png') });
  const menu = new nw.Menu();
  menu.append(
    new nw.MenuItem({
      label: "顯示主窗口",
      click: () => {
        if (global.MAIN_WINDOW == null) {
          createWindow(packageConfig.name);
        } else {
          MAIN_WINDOW.focus();
        }
      },
    })
  );
  menu.append(
    new nw.MenuItem({
      label: "退出",
      click: () => {
        killApp();
        nw.App.quit();
      },
    })
  );

  APP_TRAY.menu = menu;

  return APP_TRAY;
}

function killApp(name){
  // fix_closed_bug__0002  
  if(!name){
    try {
      name = nw.App.manifest.name;
    } catch (error) { 
      console.log(error)
    }
    if(!name){
      name = '天马erp';
    }
  }
  
  const { exec } = require("child_process");

  // 使用任务管理器命令结束进程
  exec("taskkill /F /IM "+name+".exe", (err, stdout, stderr) => {
    if (err) {
      // 处理错误
      console.error('执行的错误: '+err);
      return;
    }
    console.log('stdout: '+stdout);
    console.error('stderr: '+stderr);
  });
}
initialize();

`;

          // 替换掉旧的代码
          const updatedData = newCode; // data.replace(targetPattern, newCode);

          // 将更新后的内容写回 index.js 文件
          fs.writeFile(indexJsPath, updatedData, "utf-8", (err) => {
            if (err) {
              console.error("写入文件出错:", err);
            } else {
              console.log('win.on("closed") 事件处理代码已成功替换');
            }
          });
        } else {
          console.log("未检测到目标代码，跳过替换");
        }
      });
    } else {
      console.log("当前目录下没有找到 index.js 文件");
    }
  } catch (e) {
    console.log("replaceIndexExitAppBug err", e);
  }
}

let getUUIDIng = false;
export function initPcCode(tip) {
  if (tip && getUUIDIng) return;
  let si = null;
  try {
    si = window.require && window.require("systeminformation"); 
  }catch(e){}
 
  if (!si) {
    Bus.$emit("getSystemUuid", null);
    return;
  }
  // 获取系统UUID
  getUUIDIng = true;
  si.system()
    .then((data) => {
      getUUIDIng = false;
      window.localStorage.setItem("machineId", data.uuid);
      Bus.$emit("getSystemUuid", data.uuid);
      if (tip) {
        ElMessageBox.alert(
          `<div style="font-size:18px;">机器授权码:<br/> ${data.uuid}</div>`,
          " ",
          {
            dangerouslyUseHTMLString: true,
          }
        );
      }
    })
    .catch((error) => {
      getUUIDIng = false;
      window.localStorage.removeItem("machineId");
      Bus.$emit("getSystemUuid", null);
      if (tip) alert("获取网络信息失败:" + error);
    });
}
